// STATE 
export const showTabAdderForm = '';

// REDUCER
export const ShowTabAdderFormReducer = (state, action) => {
    switch (action.type) {
        case 'openAddTabForm':
            return true
        case 'closeAddTabForm':
            return false
        case 'formSubmitSuccess':
            return 'formSubmitted'
        default:
            return false
    }
}
